<div class="account-card">
  <div class="card-header">
    <div class="header-icon">
      <mat-icon>person</mat-icon>
    </div>
    <h2 class="card-title">{{ 'ACCOUNT.GENERAL_TITLE' | translate }}</h2>
  </div>

  <div class="card-body">
    <!-- Avatar Section -->
    <div class="profile-avatar-row">
      <div class="avatar-circle">
        <mat-icon>account_circle</mat-icon>
      </div>
      <div class="avatar-meta">
        <span class="user-display-name">{{ fullName() }}</span>
        <span class="user-display-email">{{ email() }}</span>
      </div>
    </div>

    <!-- Details Grid -->
    <div class="fields-grid">
      <div class="field-item">
        <label class="field-label">{{ 'ACCOUNT.FULL_NAME' | translate }}</label>
        @if (readOnly) {
          <div class="readonly-value">{{ fullName() }}</div>
        } @else {
          <jjames-input type="text" [placeholder]="fullName()"></jjames-input>
        }
      </div>

      <div class="field-item">
        <label class="field-label">{{ 'ACCOUNT.EMAIL' | translate }}</label>
        @if (readOnly) {
          <div class="readonly-value">{{ email() }}</div>
        } @else {
          <jjames-input type="email" [placeholder]="email()"></jjames-input>
        }
      </div>
    </div>

    @if (!readOnly) {
      <div class="card-actions">
        <jjames-button variant="primary" size="md">
          {{ 'ACCOUNT.EDIT_ACCOUNT' | translate }}
        </jjames-button>
      </div>
    }
  </div>
</div>